import { Button } from "@mui/material";
import React, { useState } from "react";
import { IconAttachment, IconGoToTab } from "../../../../utils/icons";
import { IBrand } from "../../../brand/team/data/type";
import config from "../../../../config";
import { PanelFooter } from "./PanelFooter";

interface Props {
  brand: IBrand;
  openSettings: () => void;
  s3id?: number | null;
}

export function PreviewUrlPanel({ brand, s3id, openSettings }: Props) {
  const [isCopied, setIsCopied] = useState<boolean>();

  const formatLandingUrl = (source: string = "landing", preview = false) => {
    let previewString = "";
    if (preview) {
      previewString = "&preview=true";
    }
    return `${config.EMBED_HOST}/brands/${brand.id}/${brand.slug}/single/${s3id}?source=${source}${previewString}`;
  };

  const onCopyUrlBtnClick = () => {
    navigator.clipboard.writeText(formatLandingUrl("landing"));
    setIsCopied(true);
    setTimeout(setIsCopied, 2000);
  };

  return (
    <div className="flex flex-col gap-2 justify-between h-full">
      <div className="py-6 flex flex-col w-full gap-4 flex-1 min-h-0 overflow-y-auto">
        <div className="p-4 bg-surface-2 rounded-md">
          <p
            style={{
              wordWrap: "break-word",
              fontFamily: "CircularStd",
            }}
          >
            {`${formatLandingUrl("landing", false)}`}
          </p>
        </div>
      </div>
      <PanelFooter>
        <Button
          variant="outlined"
          color="primary"
          onClick={() => window.open(formatLandingUrl("landing", true), "_blank")}
          endIcon={<IconGoToTab stroke="#444" />}
          sx={{ textTransform: "capitalize" }}
        >
          Preview Video URL
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={onCopyUrlBtnClick}
          endIcon={<IconAttachment stroke="#fff" />}
          sx={{ textTransform: "capitalize" }}
        >
          {isCopied ? "Copied!" : "Copy Video URL"}
        </Button>
      </PanelFooter>
    </div>
  );
}
